import React from "react";

interface IIndicatorScoringContext {
  updateField?: (field_name: string, field_value: string) => void
}

export const IndicatorScoringContext = React.createContext({} as IIndicatorScoringContext);
